var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M22 11.25V17.75C22 19.5421 20.5421 21 18.75 21H3V8H8V6C8 3.79442 9.79442 2 12 2C14.2056 2 16 3.79442 16 6V8H18.75C20.5421 8 22 9.458 22 11.25ZM5.5 17C5.5 17.5522 5.94775 18 6.5 18C7.05225 18 7.5 17.5522 7.5 17C7.5 16.4478 7.05225 16 6.5 16C5.94775 16 5.5 16.4478 5.5 17ZM20 17.75C20 17.7065 20 17.6 20 17.6L19.3 16.8L20 16V15.29L19.3 14.5419L20 13.7V13L19.3 12.21L20 11.4V11.3C20 10.5597 19.4403 10 18.75 10H14V6C14 4.8955 13.1045 4 12 4C10.8954 4 10 4.8955 10 6V10V19H18.75C19.4403 19 20 18.4404 20 17.75Z'
      })
    ),
    props
  );
}

module.exports = Icon;
